import Page from 'src/pages/mypage/creditcard_edit';

export default Page;
